import getByEventId from './getByEventId';

export default {
  getByEventId,
}
